import styled from "styled-components";

export const Label = styled.label`
  font-size: 1rem;
  font-weight: 700;

  padding: 0.5rem 0.5rem 0.5rem 0.5rem;

  position: absolute;
  transform: translate(0, 0.9rem) scale(1);
  transform-origin: bottom left;
  transition: all 0.2s ease-out;

  display: flex;
  box-sizing: border-box;

  width: 100%;


  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5rem;

  color: ${({theme, hasError}) => hasError ? theme.colors.red300: theme.colors.gray500};

  ${({variant}) => variant === 'select' && `
    padding: 0 0 0 4.6rem;
    transform: 'translate(0, 0.9rem) scale(1);
  `}

  &:hover {
    cursor: text;
  }
`